export default "__VITE_ASSET__e8dcd4e6__"